export interface Customer {
  id: string;
  name: string;
  email?: string | null;
}

export interface InvoiceLine {
  id?: string;
  description: string;
  quantity: number | string;
  unitAmountCents: number;
}

export interface Invoice {
  id: string;
  number: string | null;
  status: string;
  memo: string | null;
  dueOn: string | null;
  currency: string;
  totalCents: number;
  sentAt: string | null;
  hostedInvoiceUrl: string | null;
  customer: Customer | null;
  customerId?: string | null;
  lines?: InvoiceLine[];
}

export interface InvoiceDraft {
  customerId?: string | null;
  memo?: string | null;
  dueOn?: string | null;
  currency?: string | null;
  customer?: Customer | null;
  lines?: Array<{
    description?: string | null;
    quantity?: number | string | null;
    unitAmountCents?: number | null;
  }>;
}

export function formatUsdFromCents(cents: number | null | undefined): string {
  const amount = typeof cents === 'number' && Number.isFinite(cents) ? cents / 100 : 0;

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
}

export function invoiceLabel(invoice: Pick<Invoice, 'number'>): string {
  const number = invoice.number?.trim();

  if (number) return number;

  return 'Draft';
}

export function invoiceStatusLabel(status: string | null | undefined): string {
  const value = status?.trim();

  if (!value) return 'Draft';

  return value.charAt(0).toUpperCase() + value.slice(1);
}
